export const red = '#EF5C62'
export const lightRed = '#eda1a4'
export const lighterRed = '#FEEFF0'
export const darkBlue = '#156081'
export const blue = '#1362E1'
export const lightBlue = '#A8E1DB'
export const lighterBlue = '#D1F2F6'
export const green = '#0AAAAA'
export const lightGreen = '#53C3C3'
export const yellow = '#FDC453'
export const darkYellow = '#fab120'
export const white = '#FFFFFF'
export const black = '#00000'
export const dark = '#156081'
export const darkGrey = '#2F2E41'
export const lightGrey = '#F2F4F8'
export const grey = 'rgba(255, 255, 255, 0.3);'
